export const getTranslates = (state) => state.localization.translations;
export const getAvailableLangs = (state) => state.localization.langs;
export const getCurrentLang = (state) => state.localization.currentLang;

export const getLangFromUrl = (url = '') => {
  const urlArr = url.split('/');
  return urlArr[1] || '';
};